import { Link } from "react-router-dom";
import { Smartphone, QrCode } from "lucide-react";
import { API } from "@/portal/AuthContext";

export const istMobil = () => typeof navigator !== "undefined" && (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && window.innerWidth < 900));  // Prerender (Node) kennt kein navigator

/* Desktop: QR zum Scannen mit dem Handy. Handy: direkter Button „Robbie-App öffnen“ – der QR ersetzt den Button nie. */
export const AppOeffnen = ({ inApp = false, testId = "app-oeffnen" }) => {
  if (inApp && typeof window !== "undefined" && window.innerWidth < 768) return null;  // in der App auf kleinem Display: kein QR „fürs Handy“
  if (istMobil()) {
    if (inApp) return null;
    return <Link to="/app" className="inline-flex min-h-[48px] items-center gap-2 rounded-full bg-[#111] px-6 py-3 text-sm font-bold text-[#FDD105]" data-testid={`${testId}-button`}><Smartphone size={16} /> Robbie-App öffnen</Link>;
  }
  return (
    <div className="flex flex-wrap items-center gap-4 rounded-2xl border border-[#EEEAE0] bg-white p-4" data-testid={`${testId}-qr`}>
      <img src={`${API}/app/qr.svg`} alt="QR-Code: dimedial.studio/app" className="h-28 w-28 shrink-0 rounded-lg bg-white" />
      <div className="min-w-0 flex-1 basis-[10rem] text-sm text-[#111] break-words">
        <p className="flex items-center gap-1.5 font-bold"><QrCode size={15} /> Auf dem Handy öffnen</p>
        <p className="mt-1 text-xs text-[#5C574F]">QR-Code mit der Handy-Kamera scannen → <strong>dimedial.studio/app</strong> öffnet sich. Dort zeigt Robbie kurz, wie du die App auf den Home-Bildschirm legst. {inApp ? "Hier am PC kannst du alles genauso nutzen." : ""}</p>
      </div>
    </div>
  );
};
